import React from 'react'
import { Link } from 'wouter';
import Logo from '../../assets/images/Vyzle-Logo-Dark-Mode.png';
const Footer = () => {
  return (
    <div className='w-full py-6 bg-[#0f172a]  text-base text-text-dark-
    gray font-primary md:px-16 px-12 flex items-center sm:justify-between sm:flex-nowrap flex-wrap justify-center gap-6'>
      <div className='flex items-center'>
<img src={Logo} alt="Logo" className='h-10'/>
      </div>
        <div className='flex gap-4 items-center'>
            <Link to="/privacy-policy" className=' px-5 py-2 text-[#94A3B8] rounded-lg text-[15px] font-primary font-semibold hover:text-[#059669]  transition duration-300'>Privacy</Link>
             <Link to="/terms-and-conditions" className=' px-5 py-2 text-[#94A3B8] rounded-lg text-[15px] font-primary font-semibold hover:text-[#059669]  transition duration-300'>Terms</Link>
              <Link to="/support" className=' px-5 py-2 text-[#94A3B8] rounded-lg text-[15px] font-primary font-semibold hover:text-[#059669]  transition duration-300'>Support</Link>
            </div>
            <p className=' text-[14px] font-primary text-[#94A3B8]'>© {new Date().getFullYear()} Vyzle. </p>
    </div>
  )
}

export default Footer
